module.exports = __webpack_public_path__ + "static/media/mastercard.4eed6d44.png";